<div class="help-container">
  <a href="https://www.explain.fr/centre-daide" target="_blank" class="help-link text-capitalize">
    <mat-icon class="help-icon" svgIcon="help"></mat-icon>
    <span>{{ 'explain.help' | translate }}</span>
  </a>
</div>
